import { createSlice } from '@reduxjs/toolkit'
import { fetchAdminsDetails, fetchAllAdmins } from 'redux-thunk/thunk/Admin/Admin'
// import { fetchPlayerDetails } from 'redux-thunk/thunk/Players/players'

const initialState = {
  allAdmins: null,
  adminDetail: null
}

const adminSlice = createSlice({
  name: 'adminSlice',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllAdmins.fulfilled, (state, action) => {
        return {
          ...state,
          allAdmins: action.payload
        }
      })
      .addCase(fetchAdminsDetails.fulfilled, (state, action) => {
        return {
          ...state,
          adminDetail: action.payload
        }
      })
  }
})

export default adminSlice.reducer
